import PlansRoutes from './PlansRoutes';

export default PlansRoutes;
